export default "__VITE_ASSET__e7bcab55__"